import type { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

type ContactFormProps = {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

const ContactForm = ({ register, errors }: ContactFormProps) => (
  <>
    <h3>Contact Information</h3>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, marginRight: '8px' }}>
        <label htmlFor="first_name">First Name*</label>
        <input
          id="first_name"
          type="text"
          {...register('first_name', { required: true, maxLength: 40 })}
        />
        {errors.first_name && 'This field is required'}
        <br />
      </div>
      <div style={{ flex: 1 }}>
        <label htmlFor="last_name">Last Name*</label>
        <input
          id="last_name"
          type="text"
          {...register('last_name', { required: true, maxLength: 80 })}
        />
        {errors.last_name && 'This field is required'}
        <br />
      </div>
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, marginRight: '8px' }}>
        <label htmlFor="email">Email*</label>
        <input id="email" type="text" {...register('email', { required: true, maxLength: 80 })} />
        {errors.email && 'This field is required'}
        <br />
      </div>
      <div style={{ flex: 1 }}>
        <label htmlFor="phone">Phone*</label>
        <input id="phone" type="text" {...register('phone', { required: true, maxLength: 40 })} />
        {errors.phone && 'This field is required'}
        <br />
      </div>
    </div>
    <label htmlFor="URL">Website*</label>
    <input id="URL" type="text" {...register('URL', { required: true, maxLength: 80 })} />
    {errors.URL && 'This field is required'}
    <br />
    <h3>Address</h3>
    <label htmlFor="street">Street</label>
    <input id="street" type="text" {...register('street', { required: false })} />
    {errors.street && 'This field is required'}
    <br />
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, marginRight: '8px' }}>
        <label htmlFor="city">City</label>
        <input id="city" type="text" {...register('city', { required: false, maxLength: 40 })} />
        {errors.city && 'This field is required'}
        <br />
      </div>
      <div style={{ flex: 1 }}>
        <label htmlFor="state">State/Province</label>
        <input id="state" type="text" {...register('state', { required: false, maxLength: 20 })} />
        {errors.state && 'This field is required'}
        <br />
      </div>
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, marginRight: '8px' }}>
        <label htmlFor="country">Country</label>
        <input
          id="country"
          type="text"
          {...register('country', { required: false, maxLength: 40 })}
        />
        {errors.country && 'This field is required'}
        <br />
      </div>
      <div style={{ flex: 1 }}>
        <label htmlFor="zip">Zip</label>
        <input id="zip" type="text" {...register('zip', { required: false, maxLength: 20 })} />
        {errors.zip && 'This field is required'}
        <br />
      </div>
    </div>
  </>
);

export default ContactForm;
